export default "__VITE_ASSET__CSGMoqWh__"